export class SharedConstants {
  public static BREADCRUMB = 'breadcrumb';
  public static NAV_BAR_MENU_OPEN = 'navBarOpen';
  // -------------------------------------------------------------
  public static INIT_VALUE = 'Init';
  public static NOT_SUPPORTED = 'NOT_SUPPORTED';

  public static DEFAULT_PAGE_SIZE = 10;
  public static SESSIONS_PAGE_DEFAULT_PAGE_SIZE = 20;
  public static NAV_BAR_IS_COLLAPSED = 'isCollapsed';
  public static LOCAL_STORAGE_THEME_KEY = 'theme';
  public static LOCAL_STORAGE_THEME_UPDATE_KEY = 'IsThemeUpdated';

  public static LONG_DATE_FORMAT = {year: 'numeric', month: 'long', day: 'numeric' ,hour:'2-digit', minute :'2-digit'};
  public static FULL_MONTH_YEAR_DATE_FORMAT = {year: 'numeric', month: 'long'};
  public static SHORT_DATE_FORMAT = {year: 'numeric', month: 'numeric', day: 'numeric'}
  public static TIME_FORMAT_OPTIONS_12H: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: true }
  public static TIME_FORMAT_OPTIONS_24H: Intl.DateTimeFormatOptions = { hour: '2-digit', minute: '2-digit', hour12: false }
  public static LOCAL_STORAGE_TABLE_COLORS_KEY = 'table-colors';
}
